/**
 * GENERATED by scripts/capabilities-vocabulary.mjs from rista-be's
 * sales-services/rista-services/config/common/{features,modulemap,licences}.json at 2b0c577eb (release_4.0.0, 2026-09-28).
 * Do not edit: re-run the script. The backend decides which role and licence get what; the frontend
 * only names them (CAPABILITIES.md §3.6, §6).
 */

/** 169 codes: features.json's 164 and the 5 account features */
export const PERMISSION_CODES = [
  "ADVANCED_ANALYTICS",
  "AGGREGATOR_OUTLET_UPDATE",
  "ALLOW_ACTIVITY_PAY",
  "ALLOW_DELETE_API_INVENTORY_ACTIVITY",
  "ALLOW_DOWNLOAD_XML_LEDGER_REPORT",
  "ALLOW_EDITING_TRANSFER_IN",
  "ALLOW_EDIT_XML_LEDGER_MAPPING",
  "ALLOW_EXPORT_CUSTOMERS_DATA",
  "ALLOW_MANUAL_BATCH_VERIFICATION",
  "ALLOW_MANUAL_ITEM_VERIFICATION",
  "ALLOW_MEMBERSHIP_UPDATE",
  "ALLOW_MODIFICATION_OF_BILL_SEQUENCE",
  "ALLOW_NON_EXERCISED_COUPON_EXPIRY_EDIT",
  "ALLOW_RISTACARDS_DELETE",
  "ALLOW_RISTACARDS_EDIT",
  "ALLOW_RISTACARDS_REFUND",
  "ALLOW_RISTACARDS_VIEW_BALANCE_IN_LIST",
  "ALLOW_SALE_REOPEN",
  "ALLOW_TICKET_PROCESSING_ON_KDS",
  "ALLOW_TRANSFER_OUT_FOR_INCOMPLETE_INDENT",
  "ALLOW_VIDEO_ATTACHMENT_IN_SHRINKAGE",
  "API",
  "API_SUPPLIER_ITEM_EDIT",
  "APPLY_DISCOUNT",
  "APPROVE_PO",
  "APPROVE_POST_FINAL_INVENTORY_ACTIVITY",
  "AUDIT_MULTIPLE_BRANCH",
  "AUDIT_PRICE",
  "AUDIT_QUANTITY",
  "AUDIT_QUANTITY_AVAILABLE_STOCK",
  "Access",
  "Analytics",
  "BACKDATED_INVENTORY",
  "BACKDATE_AUDIT_MULTIPLE_BRANCH",
  "BACK_ORDER_FEATURE",
  "BALANCE_BY_DAYS",
  "BILL_MODIFICATION",
  "BILL_SETTLEMENT",
  "BLOCK_CUSTOMER",
  "CANCEL_SALE",
  "CANCEL_TRANSFER_IN",
  "CANCEL_TRANSFER_RETURN_IN",
  "CASH_DRAWER",
  "CASH_REGISTER",
  "CLOSE_SALE_BALANCE",
  "CLOSE_THE_OPEN_ORDERS_POST_THE_END_OF_BUSINESS_DAY",
  "COMPANY_EDIT",
  "CONTRACT_EDIT",
  "CREATE_GRN_WITHOUT_PO",
  "CREATE_NEW_ORDER",
  "CREATE_ORDERS_ON_RESERVED_TABLE",
  "CUSTOMER_EDIT",
  "DAILY_CLOSING",
  "DELETE_SALE",
  "DEVICES",
  "Dashboard",
  "EDIT_AFTER_PRINT",
  "EDIT_API_UNEDITABLE_SALEITEMS",
  "EDIT_APPROVED_PO",
  "EDIT_APPROVED_PO_GRN",
  "EDIT_CHARGE",
  "EDIT_CHARGE_AFTER_BILL_PRINT",
  "EDIT_COUPONS_OFFERS_AFTER_BILL_PRINT",
  "EDIT_CUSTOMER_AFTER_BILL_PRINT",
  "EDIT_CUSTOMER_DISPLAY",
  "EDIT_ORDER_AFTER_BILL_PRINT",
  "EDIT_POST_FINAL_INVENTORY_ACTIVITY",
  "EDIT_SERVICE_TICKET",
  "EXPORT_CHANGE_LOG",
  "GRN_ADDITIONAL_CESS_OVERRIDE",
  "GRN_CONVERSION_OVERRIDE",
  "GRN_POST_FINAL_UPDATE",
  "GRN_PREVENT_HIGHER_QUANTITY",
  "GRN_PRICE_OVERRIDE",
  "HOUSEMADE_BOM_OVERRIDE",
  "HOUSEMADE_BOP_PRICE_OVERRIDE",
  "INDENT_POST_FINAL_UPDATE",
  "INVENTORY_DIRECT_BRANCH_TRANSFER",
  "INVENTORY_DIRECT_BRANCH_TRANSFER_RETURN",
  "INVENTORY_EXPORT",
  "INVOICE_REPRINT",
  "ITEM_ACTIVITY",
  "ITEM_STOCK_UPDATE_MULTIPLE_BRANCH",
  "Inventory",
  "MANAGE_CONTRACTS",
  "MANAGE_INVENTORY_ACTIVITY",
  "MANAGE_PRINTERS",
  "MANAGE_RESOURCE",
  "MANAGE_RISTACARDS",
  "MANAGE_SUPPLIERS",
  "MANAGE_WEIGHING_SCALE",
  "MANUAL_BRANCH_CLOSE",
  "MARK_OUT_OF_STOCK",
  "MASK_CUSTOMER_PHONE",
  "MENU_SYNC",
  "MODIFY_PREPAID_BALANCE",
  "Marketing",
  "NON_CHARGEABLE_SALE",
  "OPEN_ORDER_PRINT",
  "OVERRIDE_BATCH_SELECTION_IN_POS",
  "OVERRIDE_DISCOUNT",
  "OVERRIDE_RESTRICT_INDENT",
  "PARTIAL_BATCH_VERIFICATION",
  "PAYMENTS_BY_DAYS",
  "POST_ADJUSTMENT",
  "POST_AUDIT",
  "POST_FINAL_GRN_EDIT_SUPPLIER_INVOICE_NUMBER",
  "POST_FINAL_INVENTORY_ACTIVITY",
  "POST_GRN",
  "POST_HOUSEMADE",
  "POST_INDENT",
  "POST_PROCURE",
  "POST_PURCHASE_RETURN",
  "POST_SHRINKAGE",
  "POST_TRANSFER_IN",
  "POST_TRANSFER_OUT",
  "POST_TRANSFER_RETURN_IN",
  "POST_TRANSFER_RETURN_OUT",
  "POS_PREFERENCES",
  "PO_PRICE_OVERRIDE",
  "PREPAID_SUMMARY",
  "PREVENT_ADDING_NEW_ITEMS_IN_GRN_CONTRACTGRN",
  "PRINT_BACKORDER",
  "REJECT_PENDING_RESOLUTION",
  "REJECT_POST_FINAL_INVENTORY_ACTIVITY",
  "REPRINT_KOTS",
  "REPRINT_POST_SETTLEMENT",
  "RESOLVE_REJECTED_ACTIVITY",
  "RESTRICT_DELIVERY_STATUS_UPDATE_FOR_DAAS",
  "RESTRICT_MANUAL_BATCH_VERIFICATION",
  "RETURN_SALE",
  "REVERSE_PO_APPROVAL",
  "SALES_BY_DAY",
  "SALES_EXPORT",
  "SALE_AUDIT",
  "SAVE_ORDER",
  "SEND_DIGITAL_BILL",
  "SKIP_TAX_CALCULATION_FOR_FREE_ITEMS",
  "SOLD_OUT_ITEMS",
  "SPLIT_BILL",
  "SPLIT_PAYMENTS",
  "STOCK_SETTINGS_UPDATE",
  "SUBMIT_PAST_AUDIT",
  "SUPPLIER_EDIT",
  "SUPPLIER_ITEM_OVERRIDE",
  "SYNC_HEALTH_DASHBOARD",
  "Settings",
  "TIN_ENTRY",
  "TO_PRICE_OVERRIDE",
  "TO_QUANTITY_OVERRIDE_IN_TO_VIA_INDENT",
  "TRANSFER_ITEMS",
  "TRANSFER_ITEMS_AFTER_BILL_PRINT",
  "TRANSFER_RESOLUTION",
  "UNCANCEL_SALE",
  "UNVOID_SALE",
  "UPDATE_CLOSED_SALE",
  "USERS",
  "VIEW_ADJUSTMENT_ACTIVITY_RATES",
  "VIEW_BOM_IN_ACTIVITY",
  "VIEW_CLOSED_ORDERS",
  "VIEW_CURRENT_STOCK",
  "VIEW_FEEDBACK_RESPONSE",
  "VIEW_OTHERS_ORDERS",
  "VIEW_PRODUCTION_ACTIVITY_RATES",
  "VIEW_PURCHASE_ACTIVITY_RATES",
  "VIEW_STOCK_ACTIVITY",
  "VIEW_STOCK_RATES",
  "VIEW_TRANSFER_ACTIVITY_RATES",
  "VOID_SALE",
] as const;
export type PermissionCode = (typeof PERMISSION_CODES)[number];

/** modulemap.json's 14 modules: what `permittedModules` carries */
export const MODULES = [
  "Sale",
  "Schedule",
  "Inventory",
  "Support",
  "Analytics",
  "Settings",
  "Access",
  "Account",
  "Order",
  "Delivery",
  "Service",
  "Marketing",
  "Kiosk",
  "Advanced Analytics",
] as const;
export type ModuleCode = (typeof MODULES)[number];

/** licences.json's 21 licence codes */
export const LICENCES = [
  "AALT",
  "ALT",
  "API",
  "CRM",
  "DAIA",
  "DSD",
  "INV",
  "KSK",
  "MKT",
  "POD",
  "POO",
  "POS",
  "QRB",
  "RAI",
  "RHP",
  "SCH",
  "SEP",
  "SLF",
  "SLT",
  "SOL",
  "SPT",
] as const;
export type LicenceCode = (typeof LICENCES)[number];

export const ROLES = ["User", "Manager", "Admin"] as const;
export type Role = (typeof ROLES)[number];
